@if (visible()) {
  <section class="dashboard-task-reminder" #bannerRoot aria-live="polite">
    <div class="dashboard-task-reminder__banner cg-admin-alert cg-admin-alert--warning">
      <div class="dashboard-task-reminder__icon" aria-hidden="true">
        <app-admin-icon name="triangle-alert" [size]="20" />
      </div>

      <div class="dashboard-task-reminder__copy">
        <h2 class="dashboard-task-reminder__title">Task Reminder</h2>
        <p class="dashboard-task-reminder__message" [innerHTML]="messageHtml()"></p>
      </div>

      <div class="dashboard-task-reminder__actions">
        <div class="dashboard-task-reminder__popover-wrap">
          <app-admin-button
            variant="secondary"
            type="button"
            [attr.aria-expanded]="panelOpen()"
            aria-haspopup="dialog"
            (click)="onViewTasksClick($event)"
          >
            View Tasks
          </app-admin-button>

          @if (panelOpen()) {
            <div class="dashboard-task-reminder__panel" role="dialog" aria-label="Urgent tasks">
              @if (urgentTasks().length > 0) {
                <div class="dashboard-task-reminder__panel-table">
                  <app-crm-assigned-tasks-table
                    class="is-compact"
                    [tasks]="urgentTasks()"
                    [compact]="true"
                  />
                </div>
              } @else {
                <div class="dashboard-task-reminder__empty">
                  You're all caught up! No overdue or due today tasks.
                </div>
              }
            </div>
          }
        </div>
      </div>

      <button
        type="button"
        class="dashboard-task-reminder__dismiss"
        aria-label="Dismiss task reminder"
        (click)="dismiss()"
      >
        <app-admin-icon name="x" [size]="16" />
      </button>
    </div>
  </section>
}
